import instance from '../../axios';
import { LOCAL_STORAGE_KEY } from '../../constants/LocalStorageKeys';
import { getDataFromLocalStorage, getTokenFromLocalStorage } from '../../utils/LocalStorage';

/**
 * @param {string} roleId
 * @param {string} [parentMenuSearch] - optional server filter on parent route.menu_name (trimmed on server)
 * @param {string} [parentMenuFilterType] - contains|notContains|equals|notEqual|startsWith|endsWith
 */
export const getRoleRoute = async (roleId, parentMenuSearch, parentMenuFilterType) => {
  try {
    const params = new URLSearchParams();
    if (parentMenuSearch != null && String(parentMenuSearch).trim() !== '') {
      params.set('parentMenuSearch', String(parentMenuSearch).trim());
      if (parentMenuFilterType != null && String(parentMenuFilterType).trim() !== '') {
        params.set('parentMenuFilterType', String(parentMenuFilterType).trim());
      }
    }
    const qs = params.toString();
    const url = `/admin/routes/permission/${roleId}${qs ? `?${qs}` : ''}`;
    let response = await instance.get(url, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};

export const getRoutes = async () => {
  try {
    let response = await instance.get(`/admin/routes/get_routes`, {
      headers: {
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
      },
    });
    return response;
  } catch (err) {
    return err.response || err;
  }
};
export const editPermission = async (permissionData) => {
  try {
    let response = await instance.put(
      `/admin/routes/permission/update/${permissionData?.permissionId}`,
      permissionData,
      {
        headers: {
          authorization: getTokenFromLocalStorage(),
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};
